module.exports = __webpack_public_path__ + "static/media/hand.5b8a3e69.svg";